module.exports = require('./helpers/bundle-url').getBundleURL('ex1cr') + "../images/currency.13fabf57.svg";